import clsx from "clsx";
import { PolicyDetails } from "shared";

import { unstable__Button as Button } from "@hagerty/react-components";

import { ListCard } from "../../ListCard";
import { useFeatureFlag, useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/Tag.types";
import { Vehicle } from "../../Insurance/Vehicle/Vehicle";
import styles from "./VehicleListCard.module.scss";
import { mt } from "../../../utils/tracking";

const addVehicleTagAction: TagAction = {
  actionName: "Add vehicle",
  actionType: "button",
};

type VehiclesListCardProps = {
  policy: PolicyDetails;
  className?: string;
};

export const VehiclesListCard = ({
  policy,
  className,
}: VehiclesListCardProps) => {
  const { ADD_VEHICLE } = useFeatureFlag();
  const urls = useUrls();

  const { partner, policyNumber, source, vehicles, country } = policy;
  const shouldRenderAddVehicle = source === "CORE" && partner !== "state-farm";

  return (
    <ListCard className={clsx(styles.listCard, className)}>
      <ListCard.Header
        aria-label={`Insured vehicles for policy ${policyNumber}`}
      >
        Insured vehicles
      </ListCard.Header>
      <ListCard.ExpandableRows
        maxRowCount={5}
        viewRowsLabel="View vehicles"
        hideRowsLabel="Hide vehicles"
        hasFooter={shouldRenderAddVehicle}
      >
        {vehicles.map((vehicle, index) => (
          <ListCard.Row key={index}>
            <Vehicle policy={policy} vehicle={vehicle} />
          </ListCard.Row>
        ))}
      </ListCard.ExpandableRows>
      {shouldRenderAddVehicle && (
        <ListCard.Footer>
          <Button
            variant="outline"
            color="blueberry"
            size="small"
            className={styles.addVehicleButton}
            aria-label={`Add vehicle to policy ${policyNumber}`}
            href={urls.insurance.addVehicle(
              policyNumber,
              country,
              ADD_VEHICLE.treatment
            )}
            onClick={() => mt.trackAction(addVehicleTagAction)}
          >
            Add vehicle
          </Button>
        </ListCard.Footer>
      )}
    </ListCard>
  );
};
